import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/PremiumPaywall.css';

function PremiumPaywall({ feature, description }) {
    return (
        <div className="premium-paywall">
            <div className="premium-paywall-icon">🔒</div>
            <h1>
                {feature || 'This feature'} requires Premium
            </h1>
            <p>
                {description || 'Upgrade to Premium to unlock this feature and more.'}
            </p>
            <div className="premium-paywall-buttons">
                <Link to="/shop?upgrade=premium" className="btn btn-orange btn-lg premium-paywall-btn">
                    Go Premium
                </Link>
                <Link to="/dashboard" className="btn btn-outline premium-paywall-btn">
                    Back to Dashboard
                </Link>
            </div>
        </div>
    );
}

export default PremiumPaywall;
